import Choices from "choices.js";

window.choices = {
  init: function () {
    function doOnDocumentLoaded() {
      window.choices.load();
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", doOnDocumentLoaded);
    } else {
      doOnDocumentLoaded();
    }
  },

  load: function () {
    const elements = document.querySelectorAll(
      '.gform-theme .gfield select:not([multiple="multiple"])',
    );

    if (elements) {
      elements.forEach(function (current_element, index) {
        const choices = new Choices(current_element, {
          searchEnabled: false,
          itemSelectText: "",
          allowHTML: false,
          removeItemButton: false,
          shouldSort: false,
          allowHTML: true,
        });
      });

      // aria role und aria-label
      const choicesOptions = document.querySelectorAll('.gform-theme--foundation .choices__list.choices__list--single .choices__item.choices__item--selectable')
      if (choicesOptions) {
        for (const choicesOption of choicesOptions) {
          choicesOption.setAttribute('role', 'option')
          choicesOption.closest('.choices[role="listbox"]').setAttribute('aria-label', choicesOption.innerText)
        }
      }
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  window.choices.init();
});
